import { atom } from 'jotai';

import { CountdownState } from '../models/CountdownState.type';
import { LiveClassShiftListItemProps } from '../stories/LiveClassShiftListItem';

export type ReservationModal =
  | 'modalReservationXs'
  | 'modalReservationMd'
  | 'modalReservationReserve'
  | 'modalReservationConfirm'
  | 'modalReservationNoCredits'
  | 'modalTimezone'
  | 'modalPlatformTourFeedbackPending'
  | 'modalPlatformTourVideo'
  | null;

interface ReservationData {
  numberOfCompletedLiveClasses?: number;
  totalLiveClasses?: number;
  activeModal?: ReservationModal;
  selectedLiveClass?: LiveClassShiftListItemProps;
  forceCheckNotification?: boolean;
  forceRefreshUserData?: boolean;
  joinUrl?: string;
  widgetState?: CountdownState;
}

export const reservationDataAtom = atom<ReservationData | null>(null);
